import { DropdownFilterOption } from '@workspace/interfaces/common/dropdownFilter.types';

export const isDisabled = (o: DropdownFilterOption) => !!o.disabled;
export const getLabel = (o?: DropdownFilterOption | null, placeholder?: string) => o?.label ?? placeholder ?? '';
